import { useContext } from "react";
import { AuthenticationContext } from "../contexts/AuthenticationContext";
/** Used to get the context which contains all necessary information and methods
 *  regarding the authentication.
 */
const useAuth = () => useContext(AuthenticationContext);
export default useAuth;
